import { render } from "./Projects.vue?vue&type=template&id=e909d3fc&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=e909d3fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e909d3fc"

export default script